import { Link } from 'react-router-dom';
import './MenuItem.scss';
export default function MenuItem(props) {
  const { href, title, onClick } = props;
  return (
    <Link to={href} className="childLink" onClick={onClick}>
      {title}
    </Link>
  )
}
